import Vue from 'vue';

import helpers, { methods as helperMethods } from './helpers';
import setup, { methods as setupMethods } from './setup';
import to, { methods as toMethods } from './to';

// Plain methods go on Vue.prototype, not into Vue.mixin()'s `methods` option: a mixin's methods get a
// fresh bound closure per component instance (Vue's initMethods calling bind(fn, vm) for every one, on
// every instance, app-wide); a prototype assignment is one shared function per name, found via normal
// prototype lookup, with `this` still resolving correctly for `this.name()` and template `name(...)`
// calls (both compile to a proper method call). See docs/CP-5880-frontend-performance-phase-2.md for
// the audit this relies on — specifically, nothing here may be passed around as a bare, unqualified
// function reference and invoked detached from an instance later (that call pattern loses `this`).
Object.assign(Vue.prototype, helperMethods, toMethods, setupMethods);

Vue.mixin(helpers);
Vue.mixin(to);
Vue.mixin(setup);
